export const START = "_START";
export const SUCCESS = "_SUCCESS";
export const ERROR = "_ERROR";
export const RESET = "_RESET";


export const SIGNED_OUT = 'SIGNED_OUT';
export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_COMPLETED = 'AUTH_COMPLETED';
export const SSO_IS_NOT_IMPLEMENTED = 'SSO_IS_NOT_IMPLEMENTED';
export const SET_SSO_AUTH_STATE = 'SET_SSO_AUTH_STATE';
export const SERVICE_TEMPORARILY_UNAVAILABLE = 'SERVICE_TEMPORARILY_UNAVAILABLE';

export const SET_ANNOUNCEMENT_COUNT = 'SET_ANNOUNCEMENT_COUNT';
export const SET_ANNOUNCEMENT_LIST = 'SET_ANNOUNCEMENT_LIST';
export const SET_ANNOUNCEMENT_CURRENT = 'SET_ANNOUNCEMENT_CURRENT';
export const SET_ANNOUNCEMENT_LOADING = 'SET_ANNOUNCEMENT_LOADING';
export const FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETEDBYPARAMS = 'FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETEDBYPARAMS';

export const GET_SCHEMA_ST = 'GET_SCHEMA_ST';
export const GET_YEARS_ST = 'GET_YEARS_ST';
export const GET_SCY_ST = 'GET_SCY_ST';
export const GET_PERIOD_ST = 'GET_PERIOD_ST';
export const MIN_MAX_RATING = 'MIN_MAX_RATING';
export const MIN_MAX_RATING_LOADING = 'MIN_MAX_RATING_LOADING';
export const GET_INFO_ST = 'GET_INFO_ST';
export const PHOTO_ST = 'PHOTO_ST';
export const RECALC_LOADING = 'RECALC_LOADING';

export const GET_LESSON_PLAN_CURRICULM = 'GET_LESSON_PLAN_CURRICULM';

export const NETWORK_REQUEST_SENT = 'NETWORK_REQUEST_SENT';

export const STRUCTURE_FETCH_STARTED = 'STRUCTURE_FETCH_STARTED';
export const STRUCTURE_FETCH_COMPLETED = 'STRUCTURE_FETCH_COMPLETED';

export const PROGRAM_FETCH_COMPLETED = 'PROGRAM_FETCH_COMPLETED';

export const FACULTY_FETCH_COMPLETED = 'FACULTY_FETCH_COMPLETED';
export const FACULTY_LIST_FETCH_COMPLETED = 'FACULTY_LIST_FETCH_COMPLETED';
export const FACULTY_TEACHERS_FETCH_COMPLETED = 'FACULTY_TEACHERS_FETCH_COMPLETED';
export const SET_FACULTY_LOADING = 'SET_FACULTY_LOADING';

export const CATHEDRA_LIST_FETCH_COMPLETED = 'CATHEDRA_LIST_FETCH_COMPLETED';
export const CATHEDRA_LIST_FETCH_COMPLETED_2 = 'CATHEDRA_LIST_FETCH_COMPLETED_2';
export const CATHEDRA_FETCH_COMPLETED = 'CATHEDRA_FETCH_COMPLETED';
export const CATHEDRA_FETCH_STARTED = 'CATHEDRA_FETCH_STARTED'


export const SET_CRITERIAS_LIST = 'SET_CRITERIAS_LIST'
export const SET_CRITERIAS_LOADING = 'SET_CRITERIAS_LOADING'


export const GROUP_FETCH_COMPLETED = 'GROUP_FETCH_COMPLETED';
export const GROUP_JOURNAL_FETCH_COMPLETED = 'GROUP_JOURNAL_FETCH_COMPLETED';
export const GROUP_LIST_FETCH_STARTED = 'GROUP_LIST_FETCH_STARTED';
export const GROUP_LIST_FETCH_COMPLETED = 'GROUP_LIST_FETCH_COMPLETED';
export const SET_ALL_GROUP_LIST = 'SET_ALL_GROUP_LIST';
export const SET_GROUP_LIST_VARIABLE_STUFF = 'SET_GROUP_LIST_VARIABLE_STUFF';
export const SET_EDUCATION_YEAR_VARIABLE_STUFF = 'SET_EDUCATION_YEAR_VARIABLE_STUFF';
export const GROUP_LIST_REMOVE = 'GROUP_LIST_REMOVE'
export const SET_EXTRACT_DATA = 'SET_EXTRACT_DATA';
export const SET_GROUP_LOADING = 'SET_GROUP_LOADING'


export const YEARS_FETCH_COMPLETED = 'YEARS_FETCH_COMPLETED';
export const WEEK_FETCH_COMPLETED = 'WEEK_FETCH_COMPLETED';
export const TEACHER_SCHEDULE_FETCH_COMPLETED = 'TEACHER_SCHEDULE_FETCH_COMPLETED';

export const SCHEDULE_FETCH_STARTED = 'SCHEDULE_FETCH_STARTED';
export const SCHEDULE_FETCH_COMPLETED = 'SCHEDULE_FETCH_COMPLETED';
export const SCHEDULE_FETCH_FAILED = 'SCHEDULE_FETCH_FAILED';
export const SCHEDULE_ON_DATE_FETCH_STARTED = 'SCHEDULE_ON_DATE_FETCH_STARTED';
export const SCHEDULE_ON_DATE_FETCH_COMPLETED = 'SCHEDULE_ON_DATE_FETCH_COMPLETED';
export const SET_TEACHER_SCHEDULE = 'SET_TEACHER_SCHEDULE';
export const SET_GROUPS_SCHEDULE = 'SET_GROUPS_SCHEDULE';


export const SPECIALTY_FETCHED = 'SPECIALTY_FETCHED';
export const CURRICULUM_FETCHED = 'CURRICULUM_FETCHED';
export const PLAN_FETCH_STARTED = 'PLAN_FETCH_STARTED';
export const PLAN_FETCH_COMPLETED = 'PLAN_FETCH_COMPLETED';
export const EDUCATION_YEAR_FETCHED = 'EDUCATION_YEAR_FETCHED';

// Режим «Документы об образовании» (HLMS-7898)
export const DOCUMENT_LIST_STARTED = 'DOCUMENT_LIST_STARTED';
export const DOCUMENT_LIST_COMPLETED = 'DOCUMENT_LIST_COMPLETED';
export const DOCUMENT_LIST_FAILED = 'DOCUMENT_LIST_FAILED';
export const DOCUMENT_CLEAR = 'DOCUMENT_CLEAR';
export const DOCUMENT_TYPES = 'DOCUMENT_TYPES';
export const COUNER_TYPES = 'COUNER_TYPES';
export const YEARS_TYPES = 'YEARS_TYPES';
export const FILES_LIST_STARTED = 'FILES_LIST_STARTED';
export const FILES_LIST_COMPLETED = 'FILES_LIST_COMPLETED';
export const FILES_LIST_FAILED = 'FILES_LIST_FAILED';


export const KTP_FETCH_COMPLETED = 'KTP_FETCH_COMPLETED';
export const KTP_LIST_FETCH_COMPLETED = 'KTP_LIST_FETCH_COMPLETED';

export const UMK_FETCH_STARTED = 'UMK_FETCH_STARTED';
export const UMK_FETCH_COMPLETED = 'UMK_FETCH_COMPLETED';
export const DISCIPLINE_LIST_FETCH_COMPLETED = 'DISCIPLINE_LIST_FETCH_COMPLETED';

export const FETCH_UMKLIST_DATA_STARTED = 'FETCH_UMKLIST_DATA_STARTED';
export const FETCH_UMKLIST_DATA_COMPLETED = 'FETCH_UMKLIST_DATA_COMPLETED';

export const CLEAR_UMK_DATA = 'CLEAR_UMK_DATA';

export const ALL_DISCIPLINES_FETCH_STARTED = 'ALL_DISCIPLINES_FETCH_STARTED';
export const ALL_DISCIPLINES_FETCH_COMPLETED = 'ALL_DISCIPLINES_FETCH_COMPLETED';

export const DISCIPLINE_FETCH_STARTED = 'DISCIPLINE_FETCH_STARTED';
export const DISCIPLINE_FETCH_COMPLETED = 'DISCIPLINE_FETCH_COMPLETED';

export const LK_FETCH_COMPLETED = 'LK_FETCH_COMPLETED';
export const CHAT_PHOTOS_FETCHED = 'CHAT_PHOTOS_FETCHED';
export const RATE_FETCH_COMPLETED = 'RATE_FETCH_COMPLETED';
export const LK_PHOTO_FETCH_COMPLETED = 'LK_PHOTO_FETCH_COMPLETED';

export const CHAT_FETCH_STARTED = 'CHAT_FETCH_STARTED';
export const CHAT_FETCH_COMPLETED = 'CHAT_FETCH_COMPLETED';
export const CHATS_FETCH_COMPLETED = 'CHATS_FETCH_COMPLETED';
export const USERS_FETCH_COMPLETED = 'USERS_FETCH_COMPLETED';
export const UNREAD_MESSAGE_FETCH_COMPLETED = 'MESSAGE_FETCH_COMPLETED';
export const CHAT_MESSAGES_FETCH_COMPLETED = 'CHAT_MESSAGES_FETCH_COMPLETED';

export const PORTFOLIO_DOCUMENT_LIST_FETCH_COMPLETED = 'PORTFOLIO_DOCUMENT_LIST_FETCH_COMPLETED';
export const PORTFOLIO_LOAD_FILES_LIST = 'PORTFOLIO_LOAD_FILES_LIST';
export const PORTFOLIO_DOCUMENT_UPLOAD_ERROR = 'PORTFOLIO_DOCUMENT_UPLOAD_ERROR';

export const LAYOUT_FETCH_COMPLETED = 'LAYOUT_FETCH_COMPLETED';
export const LINKS_FETCH_COMPLETED = 'LINKS_FETCH_COMPLETED';

export const EDUCATION_YEAR_FETCH_COMPLETED = 'EDUCATION_YEAR_FETCH_COMPLETED';

export const TERMS_FETCH_COMPLETED = 'TERMS_FETCH_COMPLETED';
export const NEW_TERMS_FETCH_COMPLETED = 'NEW_TERMS_FETCH_COMPLETED';

export const PROGRESS_REPORT_FETCH_STARTED = 'PROGRESS_REPORT_FETCH_STARTED';
export const PROGRESS_REPORT_FETCH_COMPLETED = 'PROGRESS_REPORT_FETCH_COMPLETED';
export const GET_TYPE_GRADES = 'GET_TYPE_GRADES';
export const GET_TASKS_FOR_INDEPENDENT_WORK_COMPLETED = 'GET_TASKS_FOR_INDEPENDENT_WORK_COMPLETED'
export const GET_SECTION_TOPIC_MAIN_COMPLETED = 'GET_SECTION_TOPIC_MAIN_COMPLETED'
export const GET_TASKS_FOR_INDEPENDENT_WORK_STARTED = 'GET_TASKS_FOR_INDEPENDENT_WORK_STARTED'
export const GET_EVENTTOOLS = 'GET_EVENTTOOLS'
export const SAVE_MARK = 'SAVE_MARK';

export const DISCIPLINES_FETCH_COMPLETED = 'DISCIPLINES_FETCH_COMPLETED';

export const PROGRESS_REPORT_LESSON_ICONS = 'PROGRESS_REPORT_LESSON_ICONS'

export const IS_BASIC_LOGIN_ALLOWED = 'IS_BASIC_LOGIN_ALLOWED';

export const CREDITS_FETCH_STARTED = 'CREDITS_FETCH_STARTED';
export const CREDITS_FETCH_COMPLETED = 'CREDITS_FETCH_COMPLETED';
export const SEMESTER_GRADE_CREDITS_FETCH_COMPLETED = 'SEMESTER_GRADE_CREDITS_FETCH_COMPLETED';
export const SET_CREDITS_LOADING = 'SET_CREDITS_LOADING';

export const COURSE_FETCH_COMPLETED = 'COURSE_FETCH_COMPLETED';
export const PERFORMANCE_FETCH_STARTED = 'PERFORMANCE_FETCH_STARTED';
export const PERFORMANCE_FETCH_COMPLETED = 'PERFORMANCE_FETCH_COMPLETED';
export const PERFORMANCE_LIST_FETCH_STARTED = 'PERFORMANCE_LIST_FETCH_STARTED';
export const PERFORMANCE_LIST_FETCH_COMPLETED = 'PERFORMANCE_LIST_FETCH_COMPLETED';

export const SET_REVIEWS_LIST = 'SET_REVIEWS_LIST';
export const SET_REVIEWS_CURRENT = 'SET_REVIEWS_CURRENT';
export const SET_REVIEWS_LOADING = 'SET_REVIEWS_LOADING';
export const SET_REVIEWS_TEACHERS = 'SET_REVIEWS_TEACHERS';
export const SET_REVIEWS_COURSES = 'SET_REVIEWS_COURSES';


export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
export const SET_DASHBOARD_CIUP_DATA = 'SET_DASHBOARD_CIUP_DATA';
export const SET_DASHBOARD_LOADING = 'SET_DASHBOARD_LOADING';
export const SET_DASHBOARD_DETAILS_EGE = 'SET_DASHBOARD_DETAILS_EGE';
export const SET_DASHBOARD_DETAILS_EIOC = 'SET_DASHBOARD_DETAILS_EIOC';
export const SET_DASHBOARD_DETAILS_TEACHERS = 'SET_DASHBOARD_DETAILS_TEACHERS';
export const SET_DASHBOARD_DETAILS_STAFF = 'SET_DASHBOARD_DETAILS_STAFF';
export const SET_DASHBOARD_DETAILS_STUDENTS = 'SET_DASHBOARD_DETAILS_STUDENTS';
export const SET_DASHBOARD_DETAILS_VSOKO = 'SET_DASHBOARD_DETAILS_VSOKO';


export const CURRENT_PERFORMANCE_FETCH_STARTED = 'CURRENT_PERFORMANCE_FETCH_STARTED';
export const CURRENT_PERFORMANCE_FETCH_COMPLETED = 'CURRENT_PERFORMANCE_FETCH_COMPLETED';
export const CURRENT_PERFORMANCE_LOADING_OFF = 'CURRENT_PERFORMANCE_LOADING_OFF';

export const BOOKS_REQUEST_FETCH_STARTED = 'BOOKS_REQUEST_FETCH_STARTED';
export const BOOKS_REQUEST_FETCH_COMPLETED = 'BOOKS_REQUEST_FETCH_COMPLETED';
export const BOOKS_REQUEST_ID_STARTED = 'BOOKS_REQUEST_ID_STARTED';
export const BOOKS_REQUEST_ID_COMPLETED = 'BOOKS_REQUEST_ID_COMPLETED';
export const NEW_ORDER_REQUEST_STARTED = 'NEW_ORDER_REQUEST_STARTED';
export const NEW_ORDER_REQUEST_COMPLETED = 'NEW_ORDER_REQUEST_COMPLETED';
export const NEW_ORDER_REQUEST_ERROR = 'NEW_ORDER_REQUEST_ERROR';
export const SEARCH_BOOKS_STARTED = 'SEARCH_BOOKS_STARTED';
export const SEARCH_BOOKS = 'SEARCH_BOOKS';
export const ADD_BOOK_TO_ORDER = 'ADD_BOOK_TO_ORDER';
export const ADD_BOOK_TO_ORDER_ERROR = 'ADD_BOOK_TO_ORDER_ERROR';

/* new book order */
export const NEW_BOOK_ORDERS_REQUEST = 'NEW_BOOK_ORDERS_REQUEST';
export const NEW_BOOK_ORDERS_REQUEST_COMPLETED = 'NEW_BOOK_ORDERS_REQUEST_COMPLETED';
export const NEW_BOOK_ORDERS_REQUEST_FAILED = 'NEW_BOOK_ORDERS_REQUEST_FAILED';

export const NEW_BOOK_ORDERS_ID_REQUEST = 'NEW_BOOK_ORDERS_ID_REQUEST';
export const NEW_BOOK_ORDERS_ID_REQUEST_COMPLETED = 'NEW_BOOK_ORDERS_ID_REQUEST_COMPLETED';
export const NEW_BOOK_ORDERS_ID_REQUEST_FAILED = 'NEW_BOOK_ORDERS_ID_REQUEST_FAILED';

export const NEW_BOOK_ORDER_CREATE_COMPLETED = 'NEW_BOOK_ORDER_CREATE_COMPLETED';

export const TEACHER_CATHEDRAS_STARTED = 'TEACHER_CATHEDRAS_STARTED';
export const TEACHER_CATHEDRAS_COMPLETED = 'TEACHER_CATHEDRAS_COMPLETED';
export const CURRICULUM_COURSES_STARTED = 'CURRICULUM_COURSES_STARTED';
export const CURRICULUM_COURSES_COMPLETED = 'CURRICULUM_COURSES_COMPLETED';


export const STUDENT_PROJECTS_FETCH_COMPLETED = 'STUDENT_PROJECTS_FETCH_COMPLETED';
export const STUDENT_PROJECT_FETCH_COMPLETED = 'STUDENT_PROJECT_FETCH_COMPLETED';
export const STUDENTS_FETCH_COMPLETED = 'STUDENTS_FETCH_COMPLETED';
// export const STUDENTS_FETCH_COMPLETED = 'STUDENTS_FETCH_COMPLETED';
export const SET_STUDENTS_PAGES_COUNT = 'SET_STUDENTS_PAGES_COUNT';
export const TASKS_FETCH_COMPLETED = 'TASKS_FETCH_COMPLETED';
export const IND_RESULT_FILES_FETCH_COMPLETED = 'IND_RESULT_FILES_FETCH_COMPLETED';
export const GROUP_RESULT_FILES_FETCH_COMPLETED = 'IND_RESULT_FILES_FETCH_COMPLETED';


export const METHODICAL_FETCH_COMPLETED = 'METHODICAL_FETCH_COMPLETED';
export const METHODICAL_CONTENT_FETCH_COMPLETED = 'METHODICAL_CONTENT_FETCH_COMPLETED';

export const GROUP_FETCHED = 'GROUP_FETCHED';
export const RESET_DOCUMENTS = 'RESET_DOCUMENTS';
export const FACULTY_FETCHED = 'FACULTY_FETCHED';
export const CONTROL_FETCHED = 'CONTROL_FETCHED';
export const CATHEDRA_FETCHED = 'CATHEDRA_FETCHED';
export const CLEAR_TEST_RESULTS = 'CLEAR_TEST_RESULTS';
export const DISCIPLINE_FETCHED = 'DISCIPLINE_FETCHED';
export const TEST_RESULT_FETCHED = 'TEST_RESULT_FETCHED';
export const ACADEMIC_YEAR_FETCHED = 'ACADEMIC_YEAR_FETCHED';
export const TEST_RESULT_PHOTO_FETCHED = 'TEST_RESULT_PHOTO_FETCHED';
export const ACADEMIC_PERIOD_FETCH_END = 'ACADEMIC_PERIOD_FETCH_END';
export const ACADEMIC_PERIOD_FETCH_START = 'ACADEMIC_PERIOD_FETCH_START';
export const COURSES_PR_FETCHED = 'COURSES_PR_FETCHED';

export const AUTH_ERROR_MODAL_CLOSED = 'AUTH_ERROR_MODAL_CLOSED';

export const UPDATE_PASSWORD_ERROR = 'UPDATE_PASSWORD_ERROR';

export const FETCH_CIRRICULUM_START = 'FETCH_CIRRICULUM_START';
export const FETCH_CIRRICULUM_COMPLETED = 'FETCH_CIRRICULUM_COMPLETED';
export const FETCH_CIRRICULUM_FAILED = 'FETCH_CIRRICULUM_FAILED';

export const FETCH_DISCIPLINES_START = 'FETCH_DISCIPLINES_START';
export const FETCH_DISCIPLINES_COMPLETED = 'FETCH_DISCIPLINES_COMPLETED';
export const FETCH_DISCIPLINES_FAILED = 'FETCH_DISCIPLINES_FAILED';

export const FETCH_DISCIPLINES_BY_TERM_FETCH_START = 'FETCH_DISCIPLINES_BY_TERM_FETCH_START';
export const FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETED = 'FETCH_DISCIPLINES_BY_TERM_FETCH_COMPLETED';
export const FETCH_DISCIPLINES_BY_TERM_FETCH_FAILED = 'FETCH_DISCIPLINES_BY_TERM_FETCH_FAILED';

export const SET_DISCIPLINE_MORE_INFO = 'SET_DISCIPLINE_MORE_INFO';

export const FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_START = 'FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_START';
export const FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_COMPLETED = 'FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_COMPLETED';
export const FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_FAILED = 'FETCH_COMPLEX_THEME_PLAN_STREAM_FETCH_FAILED';

export const FETCH_CIRRICULUM_BY_CATHEDRA_START = 'FETCH_CIRRICULUM_BY_CATHEDRA_START';
export const FETCH_CIRRICULUM_BY_CATHEDRA_COMPLETED = 'FETCH_CIRRICULUM_BY_CATHEDRA_COMPLETED';
export const FETCH_CIRRICULUM_BY_CATHEDRA_FAILED = 'FETCH_CIRRICULUM_BY_CATHEDRA_FAILED';

export const FETCH_DISCIPLINE_EDUCATION_COMPLETED = 'FETCH_DISCIPLINE_EDUCATION_COMPLETED';
export const FETCH_DISCIPLINE_EDUCATION_START = 'FETCH_DISCIPLINE_EDUCATION_START';

export const FETCH_UMK_START = 'FETCH_UMK_START';
export const FETCH_UMK_COMPLETED = 'FETCH_UMK_COMPLETED';
export const FETCH_UMK_FAILED = 'FETCH_UMK_FAILED';

export const FETCH_PERSONNEL_START = 'FETCH_PERSONNEL_START';
export const FETCH_PERSONNEL_COMPLETED = 'FETCH_PERSONNEL_COMPLETED';
export const FETCH_PERSONNEL_FAILED = 'FETCH_PERSONNEL_FAILED';
export const SET_DIVISIONS = 'SET_DIVISIONS';
export const RASHOD_REMOVE = 'RASHOD_REMOVE';
export const RASHOD_FETCH_STARTED = 'RASHOD_FETCH_STARTED';
export const SET_GROUPS_BY_SCHEDULE = 'SET_GROUPS_BY_SCHEDULE';
export const SET_RASHOD_ABSENCE = 'SET_RASHOD_ABSENCE';

export const FETCH_GRADES_START = 'FETCH_GRADES_START';
export const FETCH_GRADES_COMPLETED = 'FETCH_GRADES_COMPLETED';
export const FETCH_GRADES_FAILED = 'FETCH_GRADES_FAILED';

export const SET_GRADES_START = 'SET_GRADES_START';
export const SET_GRADES_COMPLETED = 'SET_GRADES_COMPLETED';
export const SET_GRADES_FAILED = 'SET_GRADES_FAILED';

export const FETCH_UMK_CARD_START = 'FETCH_UMK_CARD_START';
export const FETCH_UMK_CARD_COMPLETED = 'FETCH_UMK_CARD_COMPLETED';
export const FETCH_UMK_CARD_FAILED = 'FETCH_UMK_CARD_FAILED';

export const GET_LESSON_HOMEWORK_FILES_STARTED = 'GET_LESSON_HOMEWORK_FILES_STARTED';
export const GET_LESSON_HOMEWORK_FILES_COMPLETED = 'GET_LESSON_HOMEWORK_FILES_COMPLETE';
export const GET_LESSON_HOMEWORK_FILES_FAILED = 'GET_LESSON_HOMEWORK_FILED';

export const GET_LESSON_HOMEWORK_FILE_STARTED = 'GET_LESSON_HOMEWORK_FILE_STARTED';
export const GET_LESSON_HOMEWORK_FILE_COMPLETED = 'GET_LESSON_HOMEWORK_FILE_COMPLETE';
export const GET_LESSON_HOMEWORK_FILE_FAILED = 'GET_LESSON_HOMEWORK_FILED';

export const DELETE_LESSON_HOMEWORK_FILE_STARTED = 'DELETE_LESSON_HOMEWORK_FILE_STARTED';
export const DELETE_LESSON_HOMEWORK_FILE_COMPLETED = 'DELETE_LESSON_HOMEWORK_FILE_COMPLETED';
export const DELETE_LESSON_HOMEWORK_FILE_FAILED = 'DELETE_LESSON_HOMEWORK_FILE_FAILED';

export const UPLOAD_LESSON_HOMEWORK_FILE_STARTED = 'UPLOAD_LESSON_HOMEWORK_FILE_STARTED';
export const UPLOAD_LESSON_HOMEWORK_FILE_COMPLETED = 'UPLOAD_LESSON_HOMEWORK_FILE_COMPLETED';
export const UPLOAD_LESSON_HOMEWORK_FILE_FAILED = 'UPLOAD_LESSON_HOMEWORK_FILE_FAILED';

export const UPLOAD_LESSON_HOMEWORK_FILE_TEACHER_COMPLETED = 'UPLOAD_LESSON_HOMEWORK_FILE_TEACHER_COMPLETED';

export const UPLOAD_MODAL_FORM_FILE_STARTED = 'UPLOAD_MODAL_FORM_FILE_STARTED';
export const UPLOAD_MODAL_FORM_FILE_COMPLETED = 'UPLOAD_MODAL_FORM_FILE_COMPLETED';
export const UPLOAD_MODAL_FORM_FILE_FAILED = 'UPLOAD_MODAL_FORM_FILE_FAILED';


export const GET_STUDENT_HOMEWORK_FILES_STARTED = 'GET_STUDENT_HOMEWORK_FILES_STARTED';
export const GET_STUDENT_HOMEWORK_FILES_COMPLETED = 'GET_STUDENT_HOMEWORK_FILES_COMPLETE';
export const GET_STUDENT_HOMEWORK_FILES_FAILED = 'GET_STUDENT_HOMEWORK_FILED';

export const GET_STUDENT_HOMEWORK_FILE_STARTED = 'GET_STUDENT_HOMEWORK_FILE_STARTED';
export const GET_STUDENT_HOMEWORK_FILE_COMPLETED = 'GET_STUDENT_HOMEWORK_FILE_COMPLETE';
export const GET_STUDENT_HOMEWORK_FILE_FAILED = 'GET_STUDENT_HOMEWORK_FILED';

export const DELETE_STUDENT_HOMEWORK_FILE_STARTED = 'DELETE_STUDENT_HOMEWORK_FILE_STARTED';
export const DELETE_STUDENT_HOMEWORK_FILE_COMPLETED = 'DELETE_STUDENT_HOMEWORK_FILE_COMPLETED';
export const DELETE_STUDENT_HOMEWORK_FILE_FAILED = 'DELETE_STUDENT_HOMEWORK_FILE_FAILED';

export const UPLOAD_STUDENT_HOMEWORK_FILE_STARTED = 'UPLOAD_STUDENT_HOMEWORK_FILE_STARTED';
export const UPLOAD_STUDENT_HOMEWORK_FILE_COMPLETED = 'UPLOAD_STUDENT_HOMEWORK_FILE_COMPLETED';
export const UPLOAD_STUDENT_HOMEWORK_FILE_FAILED = 'UPLOAD_STUDENT_HOMEWORK_FILE_FAILED';

export const CHANGE_LESSON_HOMEWORK_TEXT_STARTED = 'CHANGE_LESSON_HOMEWORK_TEXT_STARTED';
export const CHANGE_LESSON_HOMEWORK_TEXT_COMPLETED = 'CHANGE_LESSON_HOMEWORK_TEXT_COMPLETED';
export const CHANGE_LESSON_HOMEWORK_TEXT_FAILED = 'CHANGE_LESSON_HOMEWORK_TEXT_FAILED';

export const CHANGE_STUDENT_HOMEWORK_TEXT_STARTED = 'CHANGE_STUDENT_HOMEWORK_TEXT_STARTED';
export const CHANGE_STUDENT_HOMEWORK_TEXT_COMPLETED = 'CHANGE_STUDENT_HOMEWORK_TEXT_COMPLETED';
export const CHANGE_STUDENT_HOMEWORK_TEXT_FAILED = 'CHANGE_STUDENT_HOMEWORK_TEXT_FAILED';
export const GET_SECTION_TOPIC = 'GET_SECTION_TOPIC';

export const SET_HOMEWORK_INFO = 'SET_HOMEWORK_INFO';

export const GET_LESSON_RESULT_FILE_STARTED = 'GET_LESSON_RESULT_FILE_STARTED';
export const GET_LESSON_RESULT_FILE_COMPLETED = 'GET_LESSON_RESULT_FILE_COMPLETED';
export const GET_LESSON_RESULT_FILE_FAILED = 'GET_LESSON_RESULT_FILE_FAILED';

export const GET_STUDENT_RESULT_FILE_STARTED = 'GET_STUDENT_RESULT_FILE_STARTED';
export const GET_STUDENT_RESULT_FILE_COMPLETED = 'GET_STUDENT_RESULT_FILE_COMPLETED';
export const GET_STUDENT_RESULT_FILE_FAILED = 'GET_STUDENT_RESULT_FILE_FAILED';

export const GET_COURSE_BOOKS_REQUEST_STARTED = 'GET_COURSE_BOOKS_REQUEST_STARTED';
export const GET_COURSE_BOOKS_REQUEST_COMPLETED = 'GET_COURSE_BOOKS_REQUEST_COMPLETED';
export const GET_COURSE_BOOKS_REQUEST_FAILED = 'GET_COURSE_BOOKS_REQUEST_FAILED';

export const DELETE_COURSE_BOOK_REQUEST_START = 'DELETE_COURSE_BOOK_REQUEST_START';

export const GET_BOOK_INFO_REQUEST_START = 'GET_BOOK_INFO_REQUEST_START';
export const GET_BOOK_INFO_REQUEST_COMPLETED = 'GET_BOOK_INFO_REQUEST_COMPLETED';
export const GET_BOOK_INFO_REQUEST_FAILED = 'GET_BOOK_INFO_REQUEST_FAILED';

export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_STARTED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_STARTED';
export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_COMPLETED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_COMPLETED';
export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_FAILED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_FAILED';
export const SET_EDUCATION_WORK_PROGRAMS_COUNT = 'SET_EDUCATION_WORK_PROGRAMS_COUNT';

export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_STARTED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_STARTED';
export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_COMPLETED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_COMPLETED';
export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_FAILED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_FAILED';

export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_STARTED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_STARTED';
export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_COMPLETED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_COMPLETED';
export const GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_FAILED = 'GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_FAILED';

export const GET_YEAR_SCIENTIFIC_WORK_STARTED = 'GET_YEAR_SCIENTIFIC_WORK_STARTED';
export const GET_YEAR_SCIENTIFIC_WORK_COMPLETED = 'GET_YEAR_SCIENTIFIC_WORK_COMPLETED';
export const GET_TYPEOF_SCIENTIFIC_WORK_STARTED = 'GET_YEAR_SCIENTIFIC_WORK_STARTED';
export const GET_TYPEOF_SCIENTIFIC_WORK_COMPLETED = 'GET_TYPEOF_SCIENTIFIC_WORK_COMPLETED';
export const SCIENTIFIC_WORK_FETCH_STARTED = 'SCIENTIFIC_WORK_FETCH_STARTED';
export const SCIENTIFIC_WORK_FETCH_COMPLETED = 'SCIENTIFIC_WORK_FETCH_COMPLETED';
export const SCIENTIFIC_WORK_FETCH_FAILED = 'SCIENTIFIC_WORK_FETCH_FAILED';
export const SET_SCIENTIFIC_WORK_COUNT = 'SET_SCIENTIFIC_WORK_COUNT';

export const GET_LESSON_PLAN_REQUEST_STARTED = 'GET_LESSON_PLAN_REQUEST_STARTED';
export const GET_LESSON_PLAN_REQUEST_COMPLETED = 'GET_LESSON_PLAN_REQUEST_COMPLETED';
export const GET_LESSON_PLAN_REQUEST_FAILED = 'GET_LESSON_PLAN_REQUEST_FAILED';
export const SET_LESSON_PLAN_COUNT = 'SET_LESSON_PLAN_COUNT';

export const GET_LESSON_PLAN_TERM_REQUEST_COMPLETED = 'GET_LESSON_PLAN_TERM_REQUEST_COMPLETED';

export const SET_REPORT = 'SET_REPORT';
export const RECALC_ANSWER = 'RECALC_ANSWER';
export const SET_REPORT_LOADING = 'REPORT_LOADING';
export const GET_SPECIALTY = 'GET_SPECIALTY';
export const GET_REPORT_YEARS = 'GET_REPORT_YEARS';
export const GET_REPORT_SCY = 'GET_REPORT_SCY';
export const GET_REPORT_CATHEDRA = 'GET_REPORT_CATHEDRA';
export const GET_REPORT_GROUP = 'GET_REPORT_GROUP';
export const REPORT_ACADEMIC_PERIOD_FETCH_END = 'REPORT_ACADEMIC_PERIOD_FETCH_END';
export const GET_REPORT_SCHEMA = 'GET_REPORT_SCHEMA';

export const GET_RATING_CALC = 'GET_RATING_CALC';
export const GET_DIGITAL_PORTRAIT = 'GET_DIGITAL_PORTRAIT';
export const SET_DIGITAL_PORTRAIT_LOADING = 'SET_DIGITAL_PORTRAIT_LOADING';

export const SET_PERMANENT_STAFF = 'SET_PERMANENT_STAFF'
export const SET_PERMANENT_STAFF_PAGES_COUNT = 'SET_PERMANENT_STAFF_PAGES_COUNT'
// export const SET_VARIABLE_STAFF = 'SET_VARIABLE_STAFF'

export const COMPLEX_TOPICS_DISCIPLINES_FETCH_COMPLETED = 'COMPLEX_TOPICS_DISCIPLINES_FETCH_COMPLETED'
export const COMPLEX_TOPICS_DISCIPLINES_FETCH_STARTED = 'COMPLEX_TOPICS_DISCIPLINES_FETCH_STARTED'
export const COMPLEX_TOPICS_DISCIPLINES_FETCH_FAILED = 'COMPLEX_TOPICS_DISCIPLINES_FETCH_FAILED'
export const COMPLEX_TOPICS_DISCIPLINES_GET_DISCIPLINES = 'COMPLEX_TOPICS_DISCIPLINES_GET_DISCIPLINES'
export const COMPLEX_TOPICS_DISCIPLINES_GET_CURRICULUM = 'COMPLEX_TOPICS_DISCIPLINES_GET_CURRICULUM'
export const COMPLEX_TOPICS_DISCIPLINES_CLEAR = 'COMPLEX_TOPICS_DISCIPLINES_CLEAR'
export const COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_STARTED = 'COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_STARTED'
export const COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_COMPLETED = 'COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_COMPLETED'
export const COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_ERROR = 'COMPLEX_TOPICS_DISCIPLINES_VIEW_FETCH_ERROR'
export const COMPLEX_TOPICS_DISCIPLINES_VIEW_CLEAR = 'COMPLEX_TOPICS_DISCIPLINES_VIEW_CLEAR'
export const COMPLEX_TOPICS_DISCIPLINES_SET_CURRENT = 'COMPLEX_TOPICS_DISCIPLINES_SET_CURRENT'
export const COMPLEX_THEME_PLAN_STREAM_CLEAR = 'COMPLEX_THEME_PLAN_STREAM_CLEAR'
export const COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_STARTED = 'COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_STARTED'
export const COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_ERROR = 'COMPLEX_THEME_PLAN_STREAM_CURRENT_FETCH_ERROR'

export const THEMATIC_PLANNING_SET_FILTERS = 'THEMATIC_PLANNING_SET_FILTERS'
export const THEMATIC_PLANNING_FETCH_STARTED = 'THEMATIC_PLANNING_FETCH_STARTED'
export const THEMATIC_PLANNING_FETCH_COMPLETED = 'THEMATIC_PLANNING_FETCH_COMPLETED'
export const THEMATIC_PLANNING_FETCH_FAILED = 'THEMATIC_PLANNING_FETCH_FAILED'
export const THEMATIC_PLANNING_TREE_FETCH_STARTED = 'THEMATIC_PLANNING_TREE_FETCH_STARTED'
export const THEMATIC_PLANNING_TREE_FETCH_COMPLETED = 'THEMATIC_PLANNING_TREE_FETCH_COMPLETED'
export const THEMATIC_PLANNING_TREE_FETCH_FAILED = 'THEMATIC_PLANNING_TREE_FETCH_FAILED'
export const THEMATIC_PLANNING_TREE_CLEAR = 'THEMATIC_PLANNING_TREE_CLEAR'
export const THEMATIC_PLANNING_LESSON_FETCH_STARTED = 'THEMATIC_PLANNING_LESSON_FETCH_STARTED'
export const THEMATIC_PLANNING_LESSON_FETCH_COMPLETED = 'THEMATIC_PLANNING_LESSON_FETCH_COMPLETED'
export const THEMATIC_PLANNING_LESSON_FETCH_FAILED = 'THEMATIC_PLANNING_LESSON_FETCH_FAILED'
export const THEMATIC_PLANNING_LESSON_CLEAR = 'THEMATIC_PLANNING_LESSON_CLEAR'

export const INDIVIDUAL_WORK_PLAN_FETCH_STARTED = 'INDIVIDUAL_WORK_PLAN_FETCH_STARTED'
export const INDIVIDUAL_WORK_PLAN_FETCH_COMPLETED = 'INDIVIDUAL_WORK_PLAN_FETCH_COMPLETED'
export const INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED = 'INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_STARTED'
export const INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_COMPLETED = 'INDIVIDUAL_WORK_PLAN_BY_ID_FETCH_COMPLETED'
export const INDIVIDUAL_WORK_PLAN_I_FETCH_COMPLETED = 'INDIVIDUAL_WORK_PLAN_I_FETCH_COMPLETED'
export const DELETE_INDIVIDUAL_WORK_PLAN_I_COMPLETED = 'DELETE_INDIVIDUAL_WORK_PLAN_I_COMPLETED'
export const INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED = 'INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED'
export const INDIVIDUAL_WORK_PLAN_III_GROUP_FETCH_COMPLETED = 'INDIVIDUAL_WORK_PLAN_III_GROUP_FETCH_COMPLETED'
export const INDIVIDUAL_WORK_PLAN_FILTER_FETCH_COMPLETED = 'INDIVIDUAL_WORK_PLAN_FILTER_FETCH_COMPLETED'
export const INDIVIDUAL_WORK_PLAN_FILTER_FETCH_STARTED = 'INDIVIDUAL_WORK_PLAN_FILTER_FETCH_STARTED'
export const INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED_TIMES = 'INDIVIDUAL_WORK_PLAN_III_FETCH_COMPLETED_TIMES'

export const MARK_LIST = 'MARK_LIST'
export const TERMS_LIST = 'TERMS_LIST'

export const GET_STUDENTS = 'GET_STUDENTS'

export const GET_UNIVERSITY = 'GET_UNIVERSITY'
export const GET_STRUCTURE = 'GET_STRUCTURE'
export const GET_TRAINING_QUALITY = 'GET_TRAINING_QUALITY'
export const GET_INFO_SUPP = 'GET_INFO_SUPP'
export const GET_STAFF = 'GET_STAFF'
export const GET_VKA = 'GET_VKA'

export const SELF_PHOTO = 'SELF_PHOTO'

export const SET_TESTING_LIST = 'SET_TESTING_LIST'
export const SET_TESTING_CURRENT = 'SET_TESTING_CURRENT'
export const SET_TESTING_QUESTIONS = 'SET_TESTING_QUESTIONS'
export const SET_TESTING_STATISTIC = 'SET_TESTING_STATISTIC'
export const SET_TESTING_TRY = 'SET_TESTING_TRY'
export const SET_TESTING_TOKEN = 'SET_TESTING_TOKEN'
export const SET_TESTING_LOADING = 'SET_TESTING_LOADING'

export const SET_TESTING_QUESTIONS_LIST = 'SET_TESTING_QUESTIONS_LIST'
export const SET_TESTING_QUESTIONS_CURRENT = 'SET_TESTING_QUESTIONS_CURRENT'
export const SET_TESTING_QUESTIONS_LOADING = 'SET_TESTING_QUESTIONS_LOADING'

export const SET_QUESTIONS_FILES = 'SET_QUESTIONS_FILES'
export const SET_QUESTIONS_FILES_LOADING = 'SET_QUESTIONS_FILES_LOADING'

export const SET_GROUPS_BY_COURSE = 'SET_GROUPS_BY_COURSE'

export const SET_RASHOD_COURSES = 'SET_RASHOD_COURSES'


export const PORTFOLIO_PRACTICE_FETCH_COMPLETED = 'PORTFOLIO_PRACTICE_FETCH_COMPLETED'



export const GRANTS_CHIEFS = 'GRANTS_CHIEFS'
export const GRANTS_YEARS = 'GRANTS_YEARS'
export const GRANTS_TERMS = 'GRANTS_TERMS'
export const CANDIDATS_LIST = 'CANDIDATS_LIST'
export const SET_CANDIDATS_LIST_LOADING = 'SET_CANDIDATS_LIST_LOADING'
export const GRANTS_OPTIONS = 'GRANTS_OPTIONS'
export const SET_GRANTS_OPTIONS_LOADING = 'SET_GRANTS_OPTIONS_LOADING'
export const CANDIDATS_LIST_FILE = 'CANDIDATS_LIST_FILE'
export const SET_CANDIDATS_LIST_FILE_LOADING = 'SET_CANDIDATS_LIST_FILE_LOADING'
export const SET_CANDIDAT_INFO = 'SET_CANDIDAT_INFO'
export const SET_CANDIDAT_INFO_LOADING = 'SET_CANDIDAT_INFO_LOADING'
export const GRANTS_TASK = 'GRANTS_TASK'
export const SET_GRANT_TYPES = 'SET_GRANT_TYPES'
export const SET_GRANT_TYPES_LOADING = 'SET_GRANT_TYPES_LOADING'
export const SET_SCHOLARSHIP_SETTINGS = 'SET_SCHOLARSHIP_SETTINGS'
export const SET_SCHOLARSHIP_SETTINGS_LOADING = 'SET_SCHOLARSHIP_SETTINGS_LOADING'
export const SET_SCHOLARSHIP_LEVELS = 'SET_SCHOLARSHIP_LEVELS'
export const SET_SCHOLARSHIP_LEVELS_LOADING = 'SET_SCHOLARSHIP_LEVELS_LOADING'
export const SET_SCHOLARSHIP_TREE = 'SET_SCHOLARSHIP_TREE'
export const SET_SCHOLARSHIP_TREE_LOADING = 'SET_SCHOLARSHIP_TREE_LOADING'
export const SET_SCHOLARSHIP_GRANTS_LIST = 'SET_SCHOLARSHIP_GRANTS_LIST'
export const SET_SCHOLARSHIP_GRANTS_LIST_LOADING = 'SET_SCHOLARSHIP_GRANTS_LIST_LOADING'

export const SET_ACHIEVE_DETAILS = 'SET_ACHIEVE_DETAILS'
export const METHOD_PLAN_YEARS = 'METHOD_PLAN_YEARS'
export const METHPLAN_1 = 'METHPLAN_1'
export const METHPLAN_2 = 'METHPLAN_2'
export const METHPLAN_3 = 'METHPLAN_3'
export const METHPLAN_4 = 'METHPLAN_4'
export const SET_METHPLAN_LOADING = 'SET_METHPLAN_LOADING'


export const ENCRYPTION_KEYS = 'ENCRYPTION_KEYS'
export const ENCRYPTION_KEYS_LOADING = 'ENCRYPTION_KEYS_LOADING'

export const APPLICANT = 'APPLICANT'
export const APPLICANT_LOADING = 'APPLICANT_LOADING'
export const SET_APPLICANT_PAGES_COUNT = 'SET_APPLICANT_PAGES_COUNT'

export const SET_STUDY_YEAR = 'SET_STUDY_YEAR'
export const SET_CATEGORY_APLICANT = 'SET_CATEGORY_APLICANT'
export const SET_FACULTY = 'SET_FACULTY'
export const SET_TRAINING_DIRECT = 'SET_TRAINING_DIRECT'

export const SET_EXCEL_LIST = 'SET_EXCEL_LIST'
export const SET_EXCEL_LIST_LOADING = 'SET_EXCEL_LIST_LOADING'

export const GET_REPORT_MILITARY_PROFS = 'GET_REPORT_MILITARY_PROFS'

export const SET_CAROUSEL_DATA = 'SET_CAROUSEL_DATA'

// Info Kiosk - Buttons
export const SET_INFO_KIOSK_BUTTONS = 'SET_INFO_KIOSK_BUTTONS'
export const SET_INFO_KIOSK_BUTTONS_LOADING = 'SET_INFO_KIOSK_BUTTONS_LOADING'

// Info Kiosk - Screensaver Files
export const SET_INFO_KIOSK_FILES = 'SET_INFO_KIOSK_FILES'
export const SET_INFO_KIOSK_FILES_LOADING = 'SET_INFO_KIOSK_FILES_LOADING'
export const SET_INFO_KIOSK_FILE_UPLOADING = 'SET_INFO_KIOSK_FILE_UPLOADING'

// Info Kiosk - Screensaver Settings
export const SET_INFO_KIOSK_SETTINGS = 'SET_INFO_KIOSK_SETTINGS'
export const SET_INFO_KIOSK_SETTINGS_LOADING = 'SET_INFO_KIOSK_SETTINGS_LOADING'

// Info Kiosk - Local State
export const SET_INFO_KIOSK_HAS_CHANGES = 'SET_INFO_KIOSK_HAS_CHANGES'

// TV Panel - Background & Emblem
export const SET_TV_PANEL_SETTINGS = 'SET_TV_PANEL_SETTINGS'
export const SET_TV_PANEL_SETTINGS_LOADING = 'SET_TV_PANEL_SETTINGS_LOADING'
export const SET_TV_PANEL_BG_UPLOADING = 'SET_TV_PANEL_BG_UPLOADING'
export const SET_TV_PANEL_EMBLEM_UPLOADING = 'SET_TV_PANEL_EMBLEM_UPLOADING'
// TV Panel - Screensaver Files
export const SET_TV_PANEL_SS_FILES = 'SET_TV_PANEL_SS_FILES'
export const SET_TV_PANEL_SS_FILES_LOADING = 'SET_TV_PANEL_SS_FILES_LOADING'
export const SET_TV_PANEL_SS_FILE_UPLOADING = 'SET_TV_PANEL_SS_FILE_UPLOADING'
// TV Panel - Screensaver Settings
export const SET_TV_PANEL_SS_SETTINGS = 'SET_TV_PANEL_SS_SETTINGS'
export const SET_TV_PANEL_SS_SETTINGS_LOADING = 'SET_TV_PANEL_SS_SETTINGS_LOADING'

// Program Modules
export const SET_PROGRAM_MODULES_TREE = 'SET_PROGRAM_MODULES_TREE'
export const SET_PROGRAM_MODULES_LOADING = 'SET_PROGRAM_MODULES_LOADING'
export const SET_PROGRAM_MODULES_CID = 'SET_PROGRAM_MODULES_CID'

// Info Terminal - Schema Constructor
export const SET_INFO_TERMINAL_OBJECTS = 'SET_INFO_TERMINAL_OBJECTS'
export const SET_INFO_TERMINAL_SELECTED_OBJECT = 'SET_INFO_TERMINAL_SELECTED_OBJECT'
export const SET_INFO_TERMINAL_SELECTED_AREA = 'SET_INFO_TERMINAL_SELECTED_AREA'
export const SET_INFO_TERMINAL_EDITOR_MODE = 'SET_INFO_TERMINAL_EDITOR_MODE'
export const SET_INFO_TERMINAL_DRAWING_POINTS = 'SET_INFO_TERMINAL_DRAWING_POINTS'
export const ADD_INFO_TERMINAL_DRAWING_POINT = 'ADD_INFO_TERMINAL_DRAWING_POINT'
export const CLEAR_INFO_TERMINAL_DRAWING_POINTS = 'CLEAR_INFO_TERMINAL_DRAWING_POINTS'
export const SET_INFO_TERMINAL_STAGE_SCALE = 'SET_INFO_TERMINAL_STAGE_SCALE'
export const SET_INFO_TERMINAL_STAGE_POSITION = 'SET_INFO_TERMINAL_STAGE_POSITION'
export const SET_INFO_TERMINAL_HAS_CHANGES = 'SET_INFO_TERMINAL_HAS_CHANGES'
export const ADD_INFO_TERMINAL_OBJECT = 'ADD_INFO_TERMINAL_OBJECT'
export const UPDATE_INFO_TERMINAL_OBJECT = 'UPDATE_INFO_TERMINAL_OBJECT'
export const DELETE_INFO_TERMINAL_OBJECT = 'DELETE_INFO_TERMINAL_OBJECT'
export const ADD_INFO_TERMINAL_AREA = 'ADD_INFO_TERMINAL_AREA'
export const UPDATE_INFO_TERMINAL_AREA = 'UPDATE_INFO_TERMINAL_AREA'
export const DELETE_INFO_TERMINAL_AREA = 'DELETE_INFO_TERMINAL_AREA'

// Info Terminal - API Integration (УМБ справочники)
export const SET_INFO_TERMINAL_AVAILABLE_BUILDINGS = 'SET_INFO_TERMINAL_AVAILABLE_BUILDINGS'
export const SET_INFO_TERMINAL_AVAILABLE_BUILDINGS_LOADING = 'SET_INFO_TERMINAL_AVAILABLE_BUILDINGS_LOADING'
export const SET_INFO_TERMINAL_AVAILABLE_ROOMS = 'SET_INFO_TERMINAL_AVAILABLE_ROOMS'
export const SET_INFO_TERMINAL_AVAILABLE_ROOMS_LOADING = 'SET_INFO_TERMINAL_AVAILABLE_ROOMS_LOADING'
export const SET_INFO_TERMINAL_TREE_LOADING = 'SET_INFO_TERMINAL_TREE_LOADING'
export const SET_INFO_TERMINAL_SAVING = 'SET_INFO_TERMINAL_SAVING'
export const REFRESH_INFO_TERMINAL_AREAS = 'REFRESH_INFO_TERMINAL_AREAS'
export const REFRESH_INFO_TERMINAL_IMAGE = 'REFRESH_INFO_TERMINAL_IMAGE'

export const SET_JOURNAL_DATA = 'SET_JOURNAL_DATA'
export const SET_JOURNAL_LOADING = 'SET_JOURNAL_LOADING'
export const SET_JOURNAL_FILTERS = 'SET_JOURNAL_FILTERS'

export const SET_CERT_DATA = 'SET_CERT_DATA'
export const SET_CERT_LOADING = 'SET_CERT_LOADING'
export const SET_CERT_FILTERS = 'SET_CERT_FILTERS'

export const SET_EVENTS_CALENDAR = 'SET_EVENTS_CALENDAR'
export const SET_EVENTS_CALENDAR_LOADING = 'SET_EVENTS_CALENDAR_LOADING'

// Расписание личного кабинета (занятия и мероприятия на сегодня)
export const LK_SCHEDULE_TODAY_FETCH_COMPLETED = 'LK_SCHEDULE_TODAY_FETCH_COMPLETED'

// Личное расписание преподавателя (/teacher_schedule)
export const TEACHER_SCHEDULE_YEARS_FETCHED = 'TEACHER_SCHEDULE_YEARS_FETCHED'
export const TEACHER_SCHEDULE_WEEKS_FETCHED = 'TEACHER_SCHEDULE_WEEKS_FETCHED'
export const TEACHER_SCHEDULE_TERMS_FETCHED = 'TEACHER_SCHEDULE_TERMS_FETCHED'
export const TEACHER_SCHEDULE_LESSONS_FETCH_STARTED = 'TEACHER_SCHEDULE_LESSONS_FETCH_STARTED'
export const TEACHER_SCHEDULE_LESSONS_FETCHED = 'TEACHER_SCHEDULE_LESSONS_FETCHED'
export const TEACHER_SCHEDULE_LESSONS_FETCH_FAILED = 'TEACHER_SCHEDULE_LESSONS_FETCH_FAILED'
export const TEACHER_SCHEDULE_RESET = 'TEACHER_SCHEDULE_RESET'
